import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {IPromotionItem} from './item'

export type IPromotionDetail = IPromotionItem

export const getPromotionDetail = async (id: string): Promise<ApiRes<IPromotionItem[]>> => {
    return await apiGet(API_URL, `admin/promotion/${id}/items`)
}
